import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading2 } from 'components/shared/Typography';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import {
  StyledBlock,
  StyledBlockIcon,
  StyledBlocks,
  StyledBlockSeparator,
  StyledBlockTitle,
  StyledHelp,
  StyledIntro
} from './ManfrediteHelp.styled';

const ManfrediteHelp: React.FC = () => {
  const { t } = useI18n('manfredite');
  const { locale } = useRouter();

  const { user } = useContext(LoggedUserContext);

  const blocks = [
    {
      title: t('help.items.item1.title'),
      icon: getPublicPath('/images/icons/writing.svg'),
      text: t('help.items.item1.description')
    },
    {
      title: t('help.items.item2.title'),
      icon: getPublicPath('/images/icons/critique.svg'),
      text: t('help.items.item2.description')
    },
    {
      title: t('help.items.item3.title'),
      icon: getPublicPath('/images/icons/chat.svg'),
      text: t('help.items.item3.description')
    }
  ];
  return (
    <StyledHelp>
      <StyledIntro>
        <Heading2
          editorial
          dangerouslySetInnerHTML={{ __html: t('help.title') }}
        ></Heading2>
        <p dangerouslySetInnerHTML={{ __html: t('help.description') }}></p>
      </StyledIntro>
      <StyledBlocks>
        {blocks.map((b, i) => (
          <StyledBlock key={i}>
            <StyledBlockIcon src={b.icon} alt="" />
            <StyledBlockSeparator />
            <StyledBlockTitle>{b.title}</StyledBlockTitle>
            <p dangerouslySetInnerHTML={{ __html: b.text }}></p>
          </StyledBlock>
        ))}
      </StyledBlocks>
      {!user && (
        <StyledIntro>
          <Link
            href={`${getAppUrl(APP_URLS.join, locale)}?locale=${locale}`}
            passHref
          >
            <ButtonLink variant="primary">
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('help.cta')}</span>
            </ButtonLink>
          </Link>
        </StyledIntro>
      )}
    </StyledHelp>
  );
};

export default ManfrediteHelp;
